import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import Drawer from "@mui/material/Drawer";
import {
  addToCartKiosk,
  clearCustomerCart,
  clearKioskCart,
  clientAddToCart,
  clientGiftCard,
  getCustomerCartFull,
  getKioskCart,
  tabCustomerCart
} from "../common/api/CartApi";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {ButtonGroup, Divider, Skeleton} from "@mui/material";
import MDBox from "../../components/MDBox";
import {getInventoryByType} from "../common/api/InventoryApi";
import {CalendarIcon} from "@mui/x-date-pickers";
import {displayDay, formatCurrency} from "../common/Utils";
import PlaceIcon from "@mui/icons-material/Place";
import {AccessAlarm, AllInclusive, RefreshOutlined, RemoveCircle} from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MembershipPerks from "../perks/MembershipPerks";
import InventoryImage from "../event/InventoryImage";
import MDButton from "../../components/MDButton";
import ViewInventoryModal from "../client/ViewInventoryModal";
import CartFinal from "../common/cart/CartFinal";
import Icon from "@mui/material/Icon";
import EventsMiniCard from "../client/pane/EventsMiniCard";
import ClearIcon from "@mui/icons-material/Clear";
import {removeCartItem} from "../common/api/WebApi";
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import {CompanyContext} from "../../lib/CompanyContext";
import TextField from "@mui/material/TextField";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import {CONSTANTS} from "../common/constants";

function KioskNavbar({
                       client,
                       open = false,
                       type,
                       handleClose,
                       handleSave,
                     }) {

  const [searchCriteria, setSearchCriteria] = useState();
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [cafeMode, setCafeMode] = useState(false);
  useEffect(() => {
    setCafeMode(companyContext?.company?.cafeEnabled || false);
  }, [companyContext?.company]);
  const [context, setContext] = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [guestMode, setGuestMode] = useState(!client);
  const [inventoryTypes, setInventoryTypes] = useState([]);

  const [inventoryTypeFilter, setInventoryTypeFilter] = useState([]);

  const showInventoryTypeHeader = (type) => {
    if (!inventoryTypeFilter.length) {
      return true;
    }
    for (let f in inventoryTypeFilter) {
      if (inventoryTypeFilter[f] === type.id) {
        return true;
      }
    }
    return false;
  }

  const handleSuccess = (e) => {
    setCartActive(false);
    if (!guestMode) {
      let c = {...context};
      c.refresh = true;
      setContext({...c});
    }
    handleSave();
  }
  const toggleClient = () => {
    let _gm = !guestMode;
    setGuestMode(_gm);
    if (_gm) {
      if (currentMenuItem !== 'inventory' && currentMenuItem !== 'cafe') {
        setCurrentMenuItem('inventory');
        localStorage.setItem(STORAGE_KEY, 'inventory');
      }
    }
  }

  const sendToCartFn = (item) => {
    if (!guestMode) {
      if (item?.giftRecipient?.giftCardInternal) {
        clientGiftCard(item, client.guid).then(r => {
          setFeaturedItem(null);
          handleClose(false);
        })
        return;
      }
      clientAddToCart(item, client.guid).then(r => {
        setFeaturedItem(null);
        if (item?.giftRecipient?.giftCardInternal) {
          handleClose(false);
        } else {
          getCart();
        }
      })
    } else {
      addToCartKiosk(item).then(r => {
        setFeaturedItem(null);
        getCart();
      })
    }
  }
  const [cartActive, setCartActive] = useState(false);

  useEffect(() => {
    if (!cartActive) {
      getCart();
    }
  }, [cartActive]);

  const [currentMenuItem, setCurrentMenuItem] = useState();
  const STORAGE_KEY = 'kiosk_menu_item';
  useEffect(() => {
    setCurrentMenuItem(type ? type : (localStorage.getItem(STORAGE_KEY) || 'inventory'));
  }, [])

  useEffect(() => {
    getCart();
  }, [guestMode]);

  useEffect(() => {
    if (!currentMenuItem) {
      return;
    }
    getInventoryItems(currentMenuItem);
  }, [currentMenuItem]);

  const setLastMenuItem = (item) => {
    localStorage.setItem(STORAGE_KEY, item);
    setCurrentMenuItem(item);
  }

  const isCurrentMenuItem = (item) => {
    return currentMenuItem === item;
  }

  const [inventoryItems, setInventoryItems] = useState({});

  const [eventsMode, setEventsMode] = useState(false);

  const deleteInventoryItem = async (item) => {
    setCartLoading(true);
    removeCartItem(item).then((result) => {
      getCart();
    });
  };

  const saveCartToTab = () => {
    setCartLoading(true);
    setCartActing(true);
    tabCustomerCart(client).then((result) => {
      setCartActive(false);
      setCartActing(false);
      handleSuccess({
        action: 'success'
      });
    });
  };

  const getInventoryItems = (type) => {
    if ('events' === type) {
      setEventsMode(true);
      return;
    }

    setEventsMode(false);

    setInventoryTypes([]);
    setInventoryLoading(true);

    getInventoryByType(type).then((resp) => {
      setInventoryItems(prevItems => ({
        ...prevItems,
        [type]: resp
      }));

      let _types = []
      let _inventoryTypes = []
      for (let j in resp) {
        if (_types.indexOf(resp[j].inventoryType.id) == -1) {
          _types.push(resp[j].inventoryType.id);
          _inventoryTypes.push(resp[j].inventoryType);
        }
      }
      setInventoryTypes(_inventoryTypes);
      setInventoryLoading(false);
    })
  }

  const [cart, setCart] = useState();

  const clearCart = () => {
    setCartLoading(true);
    if (client && !guestMode) {
      clearCustomerCart(client).then((resp) => {
        getCart();
      })
    } else {
      clearKioskCart().then((resp) => {
        getCart();
      })
    }
  }

  const [cartLoading, setCartLoading] = useState(false);
  const [cartActing, setCartActing] = useState(false);
  const [inventoryLoading, setInventoryLoading] = useState(false);

  const getCart = () => {
    setCartLoading(true);
    if (!guestMode) {
      getCustomerCartFull(client.guid).then((resp) => {
        setCart(resp);
        if (!cartActing) {
          setCartLoading(false);
        }
      })
    } else {
      getKioskCart().then((resp) => {
        setCart(resp);
        setCartLoading(false);
      })
    }
  }

  const sendToCart = (item) => {
    let _item = {...item};
    _item.quantity = 1;
    addToCartKiosk(_item).then((resp) => {
      getCart();
    })
  }

  const options = [
    {
      optionName: 'Inventory',
      optionKey: 'inventory',
      disabled: false,
    },
    {
      optionName: 'Cafe',
      optionKey: 'cafe',
      disabled: false,
      hidden: !cafeMode
    },
    {
      optionName: 'Memberships',
      optionKey: 'memberships',
      disabled: guestMode,
    },
    {
      optionName: 'Gift Cards',
      optionKey: 'gift-cards',
      disabled: guestMode,
    },
    // {
    //   optionName: 'Events',
    //   optionKey: 'events',
    //   disabled: guestMode,
    // },
  ]

  const [featuredItem, setFeaturedItem] = useState();
  const [sortInventory, setSortInventory] = useState({field: 'name', direction: 'asc'});

  const featureItem = (item) => {
    setFeaturedItem(item);
  }

  const sortInventoryFn = (a, b) => {
    const sortDir = sortInventory.direction === 'desc' ? -1 : 1;
    if (sortInventory.field === 'name') {
      return a.name.toUpperCase() > b.name.toUpperCase() ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'price') {
      return sortPrice(a, b) ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'id') {
      return a.id > b.id ? sortDir : sortDir * -1;
    }
    return a.id > b.id ? sortDir : sortDir * -1;
  }

  const sortPrice = (a, b) => {
    if (a.price === b.price) {
      return a.name.toUpperCase() > b.name.toUpperCase();
    } else {
      return a.price > b.price;
    }
  }

  const itemFilter = (item) => {
    if (item?.status?.id === CONSTANTS.INVENTORY_STATUS_TYPES.ARCHIVED || item?.status?.id === CONSTANTS.INVENTORY_STATUS_TYPES.UNPUBLISHED) {
      return false;
    }
    if (!searchCriteria || searchCriteria.length === 0) {
      return true;
    }
    return item?.name?.toLowerCase().match(searchCriteria?.toLowerCase())?.length > 0;
  }

  const headerFilter = (items) => {
    for (let j in items) {
      if (itemFilter(items[j])) {
        return true;
      }
    }
    return false;
  }

  const filteredResults = (items) => {
    if (!searchCriteria || searchCriteria.length === 0) {
      return items;
    }
    let _items = [];
    for (let j in items) {
      let nameCrit = items[j]?.name?.toLowerCase();
      let match = nameCrit?.match(searchCriteria?.toLowerCase());
      if (match && match.length > 0) {
        _items.push(items[j]);
      }
    }
    return _items;
  }

  return (
    <>
      <Drawer
        sx={{
          width: '90%',
          padding: '5px 20px',
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {width: '90%', padding: '5px 20px', boxSizing: 'border-box'},
        }}
        onClose={(e) => {
          handleClose(false);
        }}
        open={open && !cartActive && !featuredItem}
        anchor={'right'}
        variant={'temporary'}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            <div style={{
              position: 'sticky',
              top: '-10px',
              height: 'auto',
              zIndex: '55',
              padding: '12px 6px 12px 6px',
              margin: '0 -6px',
              background: '#fff'
            }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={9}>
                  <ButtonGroup variant="outlined" aria-label="KioskNavItems">
                    {options.filter((item) => !item.hidden).map((o, idx) => {
                      return (
                        <Button key={idx}
                                onClick={(e) => {
                                  setLastMenuItem(o.optionKey)
                                }}
                                disabled={o.disabled}
                                color={'primary'}
                                variant={'outlined'}
                                style={{
                                  display: 'inline',
                                  marginRight: '2px',
                                  marginLeft: '2px',
                                  marginBottom: '4px',
                                  borderColor: '#111',
                                  opacity: o.disabled ? '20%' : '100%',
                                  color: isCurrentMenuItem(o.optionKey) ? '#fff' : '#111',
                                  background: isCurrentMenuItem(o.optionKey) ? '#111' : '#fff'
                                }}>
                          {o.optionName}
                        </Button>
                      )
                    })
                    }
                  </ButtonGroup>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField type="text"
                             autoComplete={'off'}
                             variant="outlined"
                             value={searchCriteria || ''}
                             onChange={(e) => setSearchCriteria(e.target.value)}
                             className="form-control" id="code" aria-describedby="searchInventory"
                             label="Search Inventory"/>
                </Grid>
              </Grid>

              <div className={'d-block w-100 mt-4'} style={{
                paddingBottom: '4px',
              }}>
                <ul className={'nav'}>
                  {inventoryTypes?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((t, idx) => {
                    return (
                      <li key={idx} className={'nav-item'}>
                        <MDButton
                          onClick={(e) => {
                            document.getElementById('t-' + t.id)?.scrollIntoView({behavior: 'smooth'});
                          }}
                          style={{
                            border: 'solid 1px #ddd',
                            color: '#666',
                            marginRight: '4px',
                            marginBottom: '2px',
                          }} size="small" variant="outlined">{t.name}</MDButton>
                      </li>
                    )
                  })
                  }
                </ul>
                <Divider/>
              </div>

            </div>

            <div>
              <div>

                <Grid container spacing={2}>

                  <Grid item xs={12}>
                    {eventsMode && <>
                      <div className={'d-block my-2 pt-4'} style={{
                        display: 'block',
                        width: '100%',
                        margin: '20px',
                        paddingTop: '20px'
                      }}>
                        <h5>Events</h5>

                        <EventsMiniCard
                          hideDesc={true}
                          client={client}
                          register={(e) => {
                            setFeaturedItem(e);
                          }}
                        />

                      </div>
                    </>}
                  </Grid>

                  {!eventsMode && <>
                    {inventoryLoading && <>
                      <div className={'d-block my-2 pt-4'} style={{
                        display: 'block',
                        width: '100%',
                        margin: '20px',
                        paddingTop: '20px'
                      }}>
                        <h5><Skeleton variant="text" sx={{fontSize: '24px'}}/></h5>
                        <Grid container spacing={2}>
                          <Grid item md={4} sm={6} xs={12} lg={3}>
                            <Skeleton variant="rectangular" width={'100%'} height={120}/>
                          </Grid>
                          <Grid item md={4} sm={6} xs={12} lg={3}>
                            <Skeleton variant="rectangular" width={'100%'} height={120}/>
                          </Grid>
                          <Grid item md={4} sm={6} xs={12} lg={3}>
                            <Skeleton variant="rectangular" width={'100%'} height={120}/>
                          </Grid>
                          <Grid item md={4} sm={6} xs={12} lg={3}>
                            <Skeleton variant="rectangular" width={'100%'} height={120}/>
                          </Grid>
                        </Grid>
                      </div>
                    </>}
                    {inventoryTypes?.filter((t) => showInventoryTypeHeader(t) &&
                      headerFilter(inventoryItems[currentMenuItem]?.filter((item) => item.inventoryType.id === t.id))).sort((a, b) => a.sortOrder - b.sortOrder)?.map((t, idx) => {
                      return (
                        <div className={'d-block my-2 pt-4'} style={{
                          display: 'block',
                          width: '100%',
                          margin: '20px',
                          paddingTop: '20px'
                        }} key={idx}>
                          <div id={'t-' + t.id} style={{
                            position: 'relative',
                            left: '-999em',
                            top: '-124px'
                          }}></div>
                          <h5>{t.name}
                            {searchCriteria?.length > 0 && <>
                              <br/>
                              <span className={'inventoryFiltered'} style={{
                                color: "#999",
                                fontSize: '0.85rem'
                              }}>&nbsp;(filtered&nbsp;
                                {inventoryItems[currentMenuItem].filter((item) => item.inventoryType.id === t.id && itemFilter(item))?.length}&nbsp;of&nbsp;
                                {inventoryItems[currentMenuItem].filter((item) => item.inventoryType.id === t.id)?.length}
                                )
                            </span>
                            </>
                            }
                          </h5>
                          <Grid container spacing={2} key={idx}>

                            {inventoryItems[currentMenuItem]?.length > 0 && inventoryItems[currentMenuItem].filter((item) => item.inventoryType.id === t.id && itemFilter(item)).sort((a, b) => sortInventoryFn(a, b)).map((item, idx) => {
                              return (
                                <Grid item md={4} sm={6} xs={12} lg={3} key={idx}
                                      className={'d-inline-grid'} style={{
                                  cursor: 'pointer',
                                }} onClick={(e) => {
                                  featureItem(item)
                                }}>
                                  <div className={'psb-bordered psb-carded h-100'}>
                                    <Grid container>
                                      <Grid item sm={12} xs={12}>
                                        <InventoryImage inventory={item} key={item?.guid}/>
                                      </Grid>
                                      <Grid item sm={12} xs={12}>

                                        <h6 className={'mt-2'}>
                                          {item?.inventoryItem?.selectedPackage &&
                                            <>{item?.inventoryItem?.selectedPackage?.inventory?.name}&nbsp;</>
                                          }
                                          {item.name}
                                        </h6>
                                        <p>Price: {item?.giftCard && item?.minAmount && item?.maxAmount ? <>{formatCurrency(item.minAmount)}&nbsp;-&nbsp;{formatCurrency(item.maxAmount)} </> : <>{formatCurrency(item.price)}</>} </p>
                                        {item?.eventType?.id && <>
                                          <>
                                            {item?.inventoryItem?.selectedPackage && item?.inventoryItem?.selectedPackage.assignedInventories?.filter(a => a.included).length > 0 &&
                                              <span>
                              <p className={'mb-1'}><small><b>Party package includes:</b></small>&nbsp;
                                {item?.inventoryItem?.selectedPackage.assignedInventories?.filter(a => a.included).map((a, idx) => {
                                  return (
                                    <small key={idx}>{idx === 0 ? '' : ', '}{a.name}</small>
                                  )
                                })
                                }
                              </p>
                            </span>
                                            }

                                            {item?.inventoryItem?.selectedPackage?.packageAddOns?.length > 0 &&
                                              <>
                              <span>
                                <p className={'mb-1'}><small><b>Add-Ons:</b></small>&nbsp;
                                  {item?.inventoryItem?.selectedPackage.packageAddOns?.sort((a, b) => a.price > b.price ? -1 : 1)
                                    .map((a, idx) => {
                                      return (
                                        <small key={idx}>{idx > 0 && ', '}{a.name}</small>
                                      )
                                    })
                                  }
                                </p>
                              </span>
                                              </>
                                            }


                                            <p className={'mb-1'}>
                                              <CalendarIcon/>&nbsp;
                                              {displayDay(item.eventDate, 'MM/DD/YYYY h:mm')} - {displayDay(item.eventEndDate, 'h:mm a')}
                                            </p>
                                            {item?.eventLocation?.name && <p className={'mb-1'}>
                                              <PlaceIcon/>&nbsp;{item?.eventLocation?.name}
                                            </p>
                                            }
                                          </>
                                        </>
                                        }

                                        {item?.accountType && <>
                                          <dl className={'row'}>
                                            {item?.accountType?.recurring &&
                                              <>
                                                <dd className={'col col-sm col-sm-12'}>
                                                  <small><RefreshOutlined/> Recurring
                                                    {item.accountType?.recurrencePattern === CONSTANTS.RECURRENCE_TYPES.TIME_BASED_RECURRING && ' every ' +
                                                      item.accountType.membershipTimeDays + ' Days'}
                                                  </small>
                                                </dd>
                                                <dd className={'col col-sm col-sm-12'} style={{
                                                  display: item?.minimumMembership || item?.minimumCancellationDays ? 'none' : 'block'
                                                }}>
                                                  <small><RemoveCircle/> Cancel at any time</small>
                                                </dd>
                                                {item?.minimumMembership &&
                                                  <dd className={'col col-sm col-sm-12'}>
                                                    <small><LockPersonIcon/> Minimum {item?.minMembershipMonths} {item?.minMembershipMonths === 1 ? 'Month' : 'Months'}
                                                    </small>
                                                  </dd>
                                                }
                                                {item?.minimumCancellationDays &&
                                                  <dd className={'col col-sm col-sm-12'}>
                                                    <small><AccessAlarm/> {item?.minimumCancellationDays} {item?.minimumCancellationDays === 1 ? 'Day' : 'Days'} Cancellation
                                                      Notice
                                                    </small>
                                                  </dd>
                                                }
                                              </>
                                            }

                                            {item?.accountType?.unlimitedVisits &&
                                              <dd className={'col col-sm col-sm-12'}>
                                                <small><AllInclusive/> Unlimited Visits</small>
                                              </dd>
                                            }

                                            {item?.accountType?.timeBased &&
                                              <dd className={'col col-sm col-sm-12'}>
                                                <small><AccessTimeIcon/> Expires in
                                                  Days {item?.accountType?.membershipTimeDays}</small>
                                              </dd>
                                            }

                                          </dl>

                                        </>}

                                        <MembershipPerks inventory={item}/>

                                      </Grid>
                                    </Grid>
                                  </div>
                                </Grid>
                              )
                            })}
                          </Grid>
                        </div>
                      )
                    })
                    }
                  </>
                  }
                </Grid>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <MDBox style={{
              position: 'sticky',
              top: '10px',
            }}>
              <div className={'d-block p-2 mb-2'} style={{
                height: '50px'
              }}>
                <MDBox justifyContent={''}>
                  <button
                    size="small"
                    className={'pull-right btn-close m-1'}
                    color="inherit"
                    onClick={(e) => {
                      handleClose()
                    }}
                  >
                  </button>
                </MDBox>
              </div>
              <div className={'psb-bordered psb-carded'}>
                {cartLoading && <>
                  <h6>
                    <Skeleton variant="text" sx={{fontSize: '24px'}}/>
                  </h6>
                  <p>
                    <Skeleton variant="text" sx={{fontSize: '16px'}}/>
                  </p>
                  <p>
                    <Skeleton variant="text" sx={{fontSize: '16px'}}/>
                  </p>
                </>}
                {!cartLoading && <>
                  <h6>
                    <span>
                      {(!client || guestMode) && 'Guest'}{!guestMode && client && client?.firstName + ' ' + client?.lastName}</span>
                    {client && <MDButton
                      variant={"outlined"}
                      size="small"
                      className={'pull-right'}
                      style={{
                        minWidth: '25px',
                        color: '#000',
                        marginTop: '-8px',
                        background: !guestMode ? '#ebd204' : '#fff'
                      }}
                      color="primary"
                      onClick={(e) => {
                        toggleClient();
                      }}
                    >
                      {guestMode ? <Icon>visibility_off</Icon> : <Icon>visibility</Icon>}
                    </MDButton>}
                  </h6>
                  <Divider/>

                  <h6>
                    {cart?.items?.length === 0 ? "Cart Empty" : <a href={'#'} onClick={(e) => {
                      e.preventDefault();
                      setCartActive(true);
                    }}>
                      Items ({cart?.items?.length})
                    </a>}
                    {cart?.items?.length > 0 &&
                      <a href={'#'} className="pull-right" onClick={(e) => {
                        e.preventDefault();
                        clearCart();
                      }}><DisabledByDefaultIcon/>&nbsp;Empty Cart</a>}
                  </h6>
                  <Divider/>
                  {cart?.items?.sort((a, b) => a.cartItemId - b.cartItemId).map((item, idx) => {
                    return (
                      <span key={idx}>
                      <p>{item?.inventoryItem?.name} {item.quantity > 1 && '(' + item.quantity + ')'}<br/>
                        <b>Price:</b> {formatCurrency(item?.itemPrice)}
                        <MDButton
                          circular
                          iconOnly
                          color="primary" size={'small'}
                          className={'pull-right'}
                          onClick={(e) => {
                            deleteInventoryItem(item)
                          }}>
                          <ClearIcon/>
                        </MDButton>
                      </p>
                    </span>
                    )
                  })}

                  {cart?.items?.length > 0 &&
                    <>
                      <Divider/>

                      <div style={{
                        clear: 'both',
                        width: '100%',
                      }}></div>

                      {client?.guid?.length > 0 &&
                        <MDButton size="small" className="pull-left mt-2" color="info" onClick={() => {
                          saveCartToTab();
                        }}>Save To Tab</MDButton>}

                      <MDButton size="small" className="pull-right mt-2" color="primary" onClick={() => {
                        setCartActive(true);
                      }}>Checkout</MDButton>

                    </>}

                  <div style={{
                    clear: 'both',
                    width: '100%',
                  }}></div>

                </>}
              </div>
            </MDBox>
          </Grid>
        </Grid>
      </Drawer>

      {
        cartActive && <CartFinal
          client={guestMode ? null : client}
          cartActive={cartActive}
          callback={(e) => {
            if ('close' === e?.action) {
              setCartActive(false);
            } else if ('success' === e?.action) {
              handleSuccess(e);
            }
          }}
        />
      }

      {featuredItem && <ViewInventoryModal
        client={client}
        handleClose={() => {
          setFeaturedItem(null)
        }}
        handleSave={(featuredItem) => {
          sendToCartFn(featuredItem);
        }}
        show={featuredItem}
        inventory={featuredItem}
      />}
    </>
  );
}

export default KioskNavbar;
